<div class="card mb-4">
  <div class="card-body">
    <h2 class="card-title">Add Press Release</h2>
    <form [formGroup]="pressReleaseForm" (ngSubmit)="onSubmit()">
      <div class="mb-3">
        <label for="title" class="form-label">Title</label>
        <input type="text" class="form-control" id="title" formControlName="title" required>
        <div *ngIf="pressReleaseForm.get('title')?.invalid && pressReleaseForm.get('title')?.touched" class="text-danger">
          Title is required and must be at least 5 characters.
        </div>
      </div>
      <div class="mb-3">
        <label for="date" class="form-label">Date</label>
        <input type="date" class="form-control" id="date" formControlName="date" required>
      </div>
      <div class="mb-3">
        <label for="summary" class="form-label">Summary (max 200 characters)</label>
        <textarea class="form-control" id="summary" formControlName="summary" rows="3" maxlength="200" required></textarea>
      </div>
      <div class="mb-3">
        <label for="content" class="form-label">Full Content</label>
        <textarea class="form-control" id="content" formControlName="content" rows="5" required></textarea>
      </div>
      <div class="mb-3">
        <label for="link" class="form-label">Link (Optional)</label>
        <input type="url" class="form-control" id="link" formControlName="link">
      </div>
      <button type="submit" class="btn btn-primary" [disabled]="pressReleaseForm.invalid">Add Release</button>
    </form>
  </div>
</div>
